import React, { useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ConfirmDialog({ open, title, text, confirmLabel, danger = true, onConfirm, onClose }) {
    const { t } = useTranslation();
    const [busy, setBusy] = useState(false);
    const confirm = async () => {
        setBusy(true);
        try { await onConfirm(); } finally { setBusy(false); }
    };
    return (
        <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
            <DialogTitle sx={{ fontWeight: 700, fontSize: 17 }}>{title}</DialogTitle>
            <DialogContent><Typography sx={{ fontSize: 14, color: '#475569' }}>{text}</Typography></DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5 }}>
                <Button onClick={onClose} disabled={busy} sx={{ color: '#64748B' }}>{t('common.cancel')}</Button>
                <Button variant="contained" color={danger ? 'error' : 'primary'} onClick={confirm} disabled={busy} disableElevation>
                    {busy ? <CircularProgress size={18} sx={{ color: '#fff' }} /> : (confirmLabel || t('common.delete'))}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
